export const SIDEBAR_ANIMATION_TIMING_MS = 150;

export const SIDEBAR_LEFT_PADDING_UNITS = 2.25;

export const menuItemSxProps = {
  pl: SIDEBAR_LEFT_PADDING_UNITS,
  py: 1,
  borderRadius: '0',
};
